// NAT HOF Product Catalog
export interface Product {
  id: string;
  sku: string;
  ean: string;
  ncm: string;
  name: string;
  shortName: string;
  category: 'hidratante' | 'sabonete' | 'balsamo' | 'kit' | 'acessorio';
  subcategory?: string;
  price: number;
  originalPrice?: number;
  size: string;
  description: string;
  shortDescription: string;
  benefits: string[];
  activeIngredients: string[];
  howToUse: string;
  freeFrom: string[];
  forWhom: string[];
  rating: number;
  reviewCount: number;
  inStock: boolean;
  images: string[];
  slug: string;
  tags: string[];
  kitProducts?: string[];
}

export const products: Product[] = [
  {
    id: 'BCB01',
    sku: 'BCB01',
    ean: '7908924400056',
    ncm: '33049910',
    name: 'Bálsamo Hidratante Ozonizado com Blend de Óleos Essenciais 30ml',
    shortName: 'Bálsamo Hidratante Ozonizado',
    category: 'balsamo',
    price: 89.00,
    size: '30ml',
    description: 'Bálsamo multifuncional com óleo ozonizado e blend de óleos essenciais para hidratação profunda e regeneração da pele sensibilizada. Fórmula concentrada com rápida absorção para rosto e corpo.',
    shortDescription: 'Hidratação profunda com óleo ozonizado',
    benefits: [
      'Hidratação profunda e duradoura',
      'Auxilia na regeneração da pele',
      'Rápida absorção',
      'Multifuncional: rosto e corpo',
      'Aroma suave de óleos essenciais'
    ],
    activeIngredients: ['Óleo de girassol ozonizado', 'Lavanda', 'Palmarosa', 'Rosa-mosqueta'],
    howToUse: 'Aplique uma pequena quantidade nas áreas desejadas, massageando suavemente até completa absorção. Use diariamente ou conforme necessidade.',
    // Sem "Fragrâncias artificiais": o blend de óleos essenciais declara geraniol,
    // limoneno, linalol e farnesol com função de fragrância — o produto não pode
    // exibir o selo "Sem fragrância" (compliance regulatório).
    freeFrom: ['Álcool', 'Parabenos', 'Petrolatos', 'BPA'],
    forWhom: ['Peles muito ressecadas', 'Peles sensibilizadas por tratamentos', 'Hidratação intensiva localizada'],
    rating: 4.9,
    reviewCount: 127,
    inStock: true,
    images: ['/products/BCB01-1.png', '/products/BCB01-2.png'],
    slug: 'balsamo-hidratante-ozonizado',
    tags: ['hidratação intensiva', 'regeneração', 'óleo ozonizado', 'rosto e corpo']
  },
  {
    id: 'BBH01',
    sku: 'BBH01',
    ean: '7908924400018',
    ncm: '33049910',
    name: 'Hidratante Corporal Dermoconstrutor 1000g',
    shortName: 'Hidratante Corporal 1kg',
    category: 'hidratante',
    subcategory: 'corpo',
    price: 199.00,
    originalPrice: 289.00,
    size: '1000g',
    description: 'Hidratante corporal tamanho profissional para uso intensivo. Fórmula dermoconstrutora que auxilia na reconstrução da barreira cutânea com toque seco e rápida absorção.',
    shortDescription: 'Tamanho profissional para hidratação diária',
    benefits: [
      'Hidratação intensa e prolongada',
      'Toque seco',
      'Rápida absorção',
      'Auxilia na barreira cutânea',
      'Rendimento superior'
    ],
    activeIngredients: ['Aloe vera', 'Alantoína', 'Rosa-mosqueta', 'Ácido hialurônico'],
    howToUse: 'Após o banho, aplique em todo o corpo com movimentos circulares. Para melhores resultados, use diariamente.',
    freeFrom: ['Fragrâncias artificiais', 'Álcool', 'Parabenos', 'Petrolatos', 'BPA'],
    forWhom: ['Uso profissional', 'Uso familiar', 'Peles muito ressecadas', 'Rotina diária intensiva'],
    rating: 4.8,
    reviewCount: 89,
    inStock: true,
    images: ['/products/BBH01-1.png', '/products/BBH01-2.png'],
    slug: 'hidratante-corporal-1000g',
    tags: ['hidratação corporal', 'tamanho profissional', 'uso diário', 'barreira cutânea']
  },
  {
    id: 'BCH01',
    sku: 'BCH01',
    ean: '7908924400001',
    ncm: '33049910',
    name: 'Hidratante Corporal Dermoconstrutor 80g',
    shortName: 'Hidratante Corporal',
    category: 'hidratante',
    subcategory: 'corpo',
    price: 44.90,
    originalPrice: 56.90,
    size: '80g',
    description: 'Hidratante corporal com fórmula dermoconstrutora desenvolvida para peles sensibilizadas. Toque seco com hidratação intensa que auxilia na reconstrução da barreira cutânea.',
    shortDescription: 'Hidratação intensa com toque seco',
    benefits: [
      'Hidratação intensa e duradoura',
      'Toque seco',
      'Rápida absorção',
      'Auxilia na barreira cutânea',
      'Tamanho prático para viagem'
    ],
    activeIngredients: ['Aloe vera', 'Alantoína', 'Rosa-mosqueta', 'Ácido hialurônico'],
    howToUse: 'Após o banho, aplique em todo o corpo com movimentos circulares. Para melhores resultados, use diariamente.',
    freeFrom: ['Fragrâncias artificiais', 'Álcool', 'Parabenos', 'Petrolatos', 'BPA'],
    forWhom: ['Peles sensibilizadas', 'Peles muito ressecadas', 'Rotina diária', 'Viagem'],
    rating: 4.9,
    reviewCount: 256,
    inStock: true,
    images: ['/products/BCH01-1.png', '/products/BCH01-2.png'],
    slug: 'hidratante-corporal-80g',
    tags: ['hidratação corporal', 'toque seco', 'barreira cutânea', 'viagem']
  },
  {
    id: 'BCH02',
    sku: 'BCH02',
    ean: '7908924400025',
    ncm: '33049910',
    name: 'Hidratante Dermoconstrutor para as Mãos 80g',
    shortName: 'Hidratante para Mãos',
    category: 'hidratante',
    subcategory: 'maos',
    price: 44.90,
    originalPrice: 56.90,
    size: '80g',
    description: 'Hidratante especializado para mãos ressecadas e sensibilizadas. Fórmula com própolis e karité que oferece proteção, maciez e toque seco para uso frequente ao longo do dia.',
    shortDescription: 'Proteção e maciez para mãos sensibilizadas',
    benefits: [
      'Hidratação intensa',
      'Proteção para as mãos',
      'Toque seco',
      'Rápida absorção',
      'Maciez duradoura'
    ],
    activeIngredients: ['Aloe vera', 'Própolis', 'Manteiga de karité', 'Rosa-mosqueta', 'Ácido hialurônico'],
    howToUse: 'Aplique nas mãos sempre que sentir necessidade, massageando até completa absorção. Ideal após lavar as mãos.',
    freeFrom: ['Fragrâncias artificiais', 'Álcool', 'Parabenos', 'Petrolatos', 'BPA'],
    forWhom: ['Mãos ressecadas', 'Mãos sensibilizadas', 'Uso frequente', 'Profissionais de saúde'],
    rating: 4.8,
    reviewCount: 183,
    inStock: true,
    images: ['/products/BCH02-1.png', '/products/BCH02-2.png'],
    slug: 'hidratante-maos',
    tags: ['mãos', 'hidratação', 'própolis', 'karité', 'toque seco']
  },
  {
    id: 'BCH03',
    sku: 'BCH03',
    ean: '7908924400032',
    ncm: '33049910',
    name: 'Hidratante Dermoconstrutor para os Pés 80g',
    shortName: 'Hidratante para Pés',
    category: 'hidratante',
    subcategory: 'pes',
    price: 44.90,
    originalPrice: 56.90,
    size: '80g',
    description: 'Hidratante concentrado para pés muito ressecados e com tendência a fissuras. Fórmula intensiva com karité e alantoína que auxilia a reduzir o ressecamento e contribui para a prevenção de rachaduras.',
    shortDescription: 'Hidratação concentrada para pés ressecados',
    benefits: [
      'Hidratação intensa e concentrada',
      'Auxilia a reduzir ressecamento',
      'Contribui para evitar fissuras',
      'Toque seco',
      'Uso frequente recomendado'
    ],
    activeIngredients: ['Alantoína', 'Manteiga de karité', 'Rosa-mosqueta', 'Ácido hialurônico'],
    howToUse: 'Aplique nos pés limpos e secos, massageando especialmente as áreas mais ressecadas. Para melhores resultados, use diariamente, preferencialmente à noite.',
    freeFrom: ['Fragrâncias artificiais', 'Álcool', 'Parabenos', 'Petrolatos', 'BPA'],
    forWhom: ['Pés muito ressecados', 'Pés com tendência a fissuras', 'Rotina de cuidados noturnos'],
    rating: 4.9,
    reviewCount: 142,
    inStock: true,
    images: ['/products/BCH03-1.png', '/products/BCH03-2.png'],
    slug: 'hidratante-pes',
    tags: ['pés', 'hidratação intensiva', 'fissuras', 'ressecamento']
  },
  {
    id: 'BCS01',
    sku: 'BCS01',
    ean: '7908924400049',
    ncm: '34013000',
    name: 'Sabonete Líquido Extra Suave 150ml',
    shortName: 'Sabonete Extra Suave',
    category: 'sabonete',
    price: 39.90,
    originalPrice: 52.90,
    size: '150ml',
    description: 'Sabonete líquido com fórmula extra suave para limpeza delicada de peles sensibilizadas. Enriquecido com camomila e chá-verde para conforto e hidratação durante a limpeza.',
    shortDescription: 'Limpeza suave que respeita a pele',
    benefits: [
      'Limpeza suave e delicada',
      'Não resseca a pele',
      'Mantém a hidratação natural',
      'Conforto durante e após o uso',
      'Ideal para uso diário'
    ],
    activeIngredients: ['Camomila', 'Chá-verde', 'Ácido hialurônico'],
    howToUse: 'Aplique uma pequena quantidade na pele úmida, massageie suavemente formando espuma leve e enxágue. Use no banho diário.',
    freeFrom: ['Fragrâncias artificiais', 'Álcool', 'Parabenos', 'Petrolatos', 'BPA'],
    forWhom: ['Peles sensibilizadas', 'Peles delicadas', 'Limpeza diária', 'Todas as idades'],
    rating: 4.7,
    reviewCount: 98,
    inStock: true,
    images: ['/products/BCS01-1.png', '/products/BCS01-2.png'],
    slug: 'sabonete-extra-suave',
    tags: ['limpeza', 'sabonete', 'suave', 'camomila', 'chá-verde']
  },
  {
    id: 'BCN01',
    sku: 'BCN01',
    ean: '7908924400070',
    ncm: '42023200',
    name: 'Necessaire Exclusiva Bordada NAT HOF',
    shortName: 'Necessaire Exclusiva',
    category: 'acessorio',
    price: 69.90,
    originalPrice: 89.00,
    size: 'Único',
    description: 'Necessaire exclusiva NAT HOF com bordado elegante. Perfeita para organizar sua rotina de cuidados, seja em casa ou em viagens.',
    shortDescription: 'Organize sua rotina com elegância',
    benefits: [
      'Design exclusivo bordado',
      'Espaço amplo',
      'Material resistente',
      'Ideal para viagem',
      'Presente perfeito'
    ],
    activeIngredients: [],
    howToUse: 'Use para organizar seus produtos NAT HOF favoritos.',
    freeFrom: [],
    forWhom: ['Organização', 'Viagem', 'Presente'],
    rating: 5.0,
    reviewCount: 45,
    inStock: true,
    images: ['/products/BCN01-1.png', '/products/BCN01-2.png'],
    slug: 'necessaire-exclusiva',
    tags: ['acessório', 'necessaire', 'organização', 'viagem', 'presente']
  },
  {
    id: 'KIT03',
    sku: 'KIT03',
    ean: '7908924400124',
    ncm: '',
    name: 'Kit Hidratação Diária Essencial',
    shortName: 'Kit Essencial',
    category: 'kit',
    price: 119.90,
    originalPrice: 139.90,
    size: 'Kit completo',
    description: 'Tudo que você precisa para uma hidratação completa: corpo, mãos e pés. Os três produtos essenciais para o cuidado diário da pele sensibilizada.',
    shortDescription: 'Corpo + Mãos + Pés',
    benefits: [
      'Economia de 14%',
      'Hidratação completa',
      'Cuidado para todo o corpo',
      'Produtos complementares',
      'Rotina prática'
    ],
    activeIngredients: ['Aloe vera', 'Alantoína', 'Karité', 'Própolis', 'Ácido hialurônico'],
    howToUse: 'Use o Hidratante Corporal após o banho, o de Mãos ao longo do dia e o de Pés preferencialmente à noite.',
    freeFrom: ['Fragrâncias artificiais', 'Álcool', 'Parabenos', 'Petrolatos', 'BPA'],
    forWhom: ['Hidratação completa', 'Pele muito ressecada', 'Rotina diária'],
    rating: 4.9,
    reviewCount: 89,
    inStock: true,
    images: ['/products/KIT03-1.png'],
    slug: 'kit-hidratacao-diaria-essencial',
    kitProducts: ['BCH01', 'BCH02', 'BCH03'],
    tags: ['kit', 'hidratação completa', 'corpo', 'mãos', 'pés', 'economia']
  },
  {
    id: 'KIT02',
    sku: 'KIT02',
    ean: '7908924400117',
    ncm: '',
    name: 'Kit Hidratação e Limpeza Suave',
    shortName: 'Kit Hidratação + Limpeza',
    category: 'kit',
    price: 149.90,
    originalPrice: 179.90,
    size: 'Kit completo',
    description: 'A rotina completa de cuidado corporal, das mãos e dos pés, com a limpeza suave que respeita a pele sensível. Combina o sabonete líquido extra suave com os três hidratantes dermoconstrutores.',
    shortDescription: 'Limpeza + Hidratação corpo, mãos e pés',
    benefits: [
      'Economia de 17%',
      'Rotina completa de cuidado',
      'Limpeza sem ressecamento',
      'Hidratação de corpo, mãos e pés',
      'Ideal para iniciantes'
    ],
    activeIngredients: ['Camomila', 'Chá-verde', 'Aloe vera', 'Própolis', 'Karité', 'Ácido hialurônico'],
    howToUse: 'Use o Sabonete durante o banho e aplique o Hidratante Corporal logo após. Complemente com o de Mãos ao longo do dia e o de Pés à noite.',
    freeFrom: ['Fragrâncias artificiais', 'Álcool', 'Parabenos', 'Petrolatos', 'BPA'],
    forWhom: ['Iniciantes em skincare', 'Rotina completa', 'Peles sensíveis'],
    rating: 4.8,
    reviewCount: 112,
    inStock: true,
    images: ['/products/KIT02-1.png'],
    slug: 'kit-hidratacao-e-limpeza-suave',
    kitProducts: ['BCS01', 'BCH01', 'BCH02', 'BCH03'],
    tags: ['kit', 'limpeza', 'hidratação', 'rotina completa', 'economia']
  },
  {
    id: 'KIT01',
    sku: 'KIT01',
    ean: '7908924400100',
    ncm: '',
    name: 'Kit Regeneração e Hidratação Intensiva',
    shortName: 'Kit Regeneração Intensiva',
    category: 'kit',
    price: 199.90,
    originalPrice: 259.90,
    size: 'Kit completo',
    description: 'Rotina completa de cuidado para pele sensibilizada e fragilizada: limpeza suave, hidratação corporal, cuidado de mãos e pés, e bálsamo ozonizado para áreas que precisam de atenção especial.',
    shortDescription: 'Regeneração + Hidratação completa',
    benefits: [
      'Economia de 23%',
      'Rotina completa de regeneração',
      'Hidratação de corpo, mãos e pés',
      'Bálsamo para áreas específicas',
      'Ideal para peles muito sensibilizadas'
    ],
    activeIngredients: ['Óleo ozonizado', 'Aloe vera', 'Alantoína', 'Própolis', 'Karité', 'Rosa-mosqueta', 'Ácido hialurônico'],
    howToUse: 'Use o Sabonete no banho, o Hidratante Corporal após, o de Mãos ao longo do dia, o de Pés à noite, e o Bálsamo nas áreas que precisam de atenção especial.',
    freeFrom: ['Fragrâncias artificiais', 'Álcool', 'Parabenos', 'Petrolatos', 'BPA'],
    forWhom: ['Peles muito sensibilizadas', 'Regeneração intensiva', 'Pacientes em tratamento'],
    rating: 4.9,
    reviewCount: 76,
    inStock: true,
    images: ['/products/KIT01-1.png'],
    slug: 'kit-regeneracao-e-hidratacao-intensiva',
    kitProducts: ['BCB01', 'BCH01', 'BCH02', 'BCH03', 'BCS01'],
    tags: ['kit', 'regeneração', 'hidratação intensiva', 'economia']
  },
  {
    id: 'KIT04',
    sku: 'KIT04',
    ean: '7908924400087',
    ncm: '33049910',
    name: 'Kit Mãos e Pés NAT HOF',
    shortName: 'Kit Mãos e Pés',
    category: 'kit',
    price: 79.90,
    size: 'Kit completo',
    description: 'Dupla de cuidado diário para as áreas que mais trabalham: os hidratantes dermoconstrutores para mãos e pés ressecados, formulados para pele sensível e uso contínuo.',
    shortDescription: 'Mãos + Pés',
    benefits: [
      'Hidratação intensa de mãos e pés',
      'Toque seco',
      'Uso contínuo ao longo do dia',
      'Produtos complementares',
      'Tamanho prático'
    ],
    activeIngredients: ['Aloe vera', 'Própolis', 'Manteiga de karité', 'Alantoína', 'Rosa-mosqueta', 'Ácido hialurônico'],
    howToUse: 'Aplique o Hidratante para Mãos ao longo do dia e o de Pés preferencialmente à noite, em pele limpa.',
    freeFrom: ['Fragrâncias artificiais', 'Álcool', 'Parabenos', 'Petrolatos', 'BPA'],
    forWhom: ['Mãos e pés ressecados', 'Uso frequente', 'Profissionais de saúde'],
    rating: 0,
    reviewCount: 0,
    inStock: true,
    images: ['https://cdn.shopify.com/s/files/1/0696/8944/2491/files/KIT04-kit-maos-e-pes-nathof.png?v=1789728629'],
    slug: 'kit-maos-e-pes-nat-hof',
    kitProducts: ['BCH02', 'BCH03'],
    tags: ['kit', 'mãos', 'pés', 'hidratação', 'rotina']
  },
  {
    id: 'KIT05',
    sku: 'KIT05',
    ean: '7908924400094',
    ncm: '33049910',
    name: 'Kit Corpo e Banho NAT HOF',
    shortName: 'Kit Corpo e Banho',
    category: 'kit',
    price: 75.90,
    size: 'Kit completo',
    description: 'O essencial do banho ao pós-banho: limpeza que respeita a barreira da pele sensível e hidratação corporal de uso diário, ambos sem fragrância.',
    shortDescription: 'Corpo + Banho',
    benefits: [
      'Limpeza suave sem ressecar',
      'Hidratação corporal diária',
      'Toque seco',
      'Rotina completa de banho',
      'Tamanho prático'
    ],
    activeIngredients: ['Camomila', 'Chá-verde', 'Aloe vera', 'Alantoína', 'Rosa-mosqueta', 'Ácido hialurônico'],
    howToUse: 'Use o Sabonete durante o banho e aplique o Hidratante Corporal logo após, com a pele ainda levemente úmida.',
    freeFrom: ['Fragrâncias artificiais', 'Álcool', 'Parabenos', 'Petrolatos', 'BPA'],
    forWhom: ['Rotina de banho diária', 'Peles sensíveis', 'Uso familiar'],
    rating: 0,
    reviewCount: 0,
    inStock: true,
    images: ['https://cdn.shopify.com/s/files/1/0696/8944/2491/files/KIT05-kit-corpo-e-banho-nathof.png?v=1789728630'],
    slug: 'kit-corpo-e-banho-nat-hof',
    kitProducts: ['BCS01', 'BCH01'],
    tags: ['kit', 'corpo', 'banho', 'sabonete', 'hidratação']
  }
];

export const getProductById = (id: string): Product | undefined => {
  return products.find(p => p.id === id);
};

export const getProductBySlug = (slug: string): Product | undefined => {
  return products.find(p => p.slug === slug);
};

export const getProductsByCategory = (category: Product['category']): Product[] => {
  return products.filter(p => p.category === category);
};

export const getBestSellers = (): Product[] => {
  return products.filter(p => p.reviewCount > 80).sort((a, b) => b.reviewCount - a.reviewCount);
};

export const getKits = (): Product[] => {
  return products.filter(p => p.category === 'kit');
};
